var _rect, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLogoTypeformdark = function SvgLogoTypeformdark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#fff",
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-typeformdark_svg__a)",
    d: "M1 1h21.92v22H1z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "logo-typeformdark_svg__a",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo-typeformdark_svg__b",
    transform: "scale(.00389)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M121.24.474c33.019-2.718 56.734 6.045 82.25 31.547 27.549 27.532 45.864 63.212 50.8 101.218 5.492 42.266-2.062 73.807-25.326 96.898-22.247 22.08-54.74 29.364-98.146 25.735l-1.797-.158c-36.963-3.398-63.107-15.517-88.438-41.171C13.526 187.14-.732 156.026.029 123.37.401 107.383 4.93 93.758 13.664 80.39c5.726-8.765 11.54-15.602 23.704-28.14l4.06-4.158 4.474-4.536C74.73 14.58 93.707 2.741 121.24.475Zm80.288 33.51C176.586 9.057 153.672.59 121.468 3.241c-27.14 2.234-45.78 14.091-74.95 43.635l-2.11 2.141C30.198 63.465 23.538 70.852 17.67 79.395l-.854 1.26-.828 1.252c-8.461 12.95-12.824 26.078-13.184 41.528-.743 31.846 13.194 62.258 39.754 89.157 25.267 25.59 51.225 37.4 88.49 40.514l1.85.148c41.744 3.21 72.867-4.002 94.11-25.087 22.57-22.402 29.92-53.088 24.53-94.57-4.855-37.382-22.884-72.503-50.01-99.613ZM166.984 93.39v13.56h-28.797v77.712h-14.345V106.95H95.045V93.39h71.94Z",
    fill: "#262627",
    id: "logo-typeformdark_svg__b"
  }))));
};

export default SvgLogoTypeformdark;